<template>
    <span>
        
        <v-tooltip  content-class="pa-0 text-body" right nudge-right="-60" nudge-bottom="36" color="white" open-delay="500">
            <template v-slot:activator="{ on, attrs }"><span v-bind="attrs" v-on="on">
                <ActionButton ml :disabled="disableAll||!canPlanned" class="palette-2 bordered no-text" icon="calendar" @click="onPlanned" ></ActionButton>
            </span></template>
            <div class="pa-1 bordered text-small">Zet werkbon in status Ingepland</div>
        </v-tooltip>

        <v-tooltip  content-class="pa-0 text-body" right nudge-right="-60" nudge-bottom="36" color="white" open-delay="500">
            <template v-slot:activator="{ on, attrs }"><span v-bind="attrs" v-on="on">
                <ActionButton ml :disabled="disableAll||!canExecuting"  class="palette-3 bordered no-text" icon="workorder" @click="onExecuting" ></ActionButton>
            </span></template>
            <div class="pa-1 bordered text-small">Zet werkbon naar status Werkvloer</div>
        </v-tooltip>

        <v-tooltip  content-class="pa-0 text-body" right nudge-right="-60" nudge-bottom="36" color="white" open-delay="500">
            <template v-slot:activator="{ on, attrs }"><span v-bind="attrs" v-on="on">
                <ActionButton ml :disabled="disableAll||!canExecuted"  class="palette-5 bordered no-text" icon="finish" @click="onExecuted" ></ActionButton>
            </span></template>
            <div class="pa-1 bordered text-small">Zet werkbon in status Uitgevoerd</div>
        </v-tooltip>

        <v-tooltip  content-class="pa-0 text-body" right nudge-right="-60" nudge-bottom="36" color="white" open-delay="500">
            <template v-slot:activator="{ on, attrs }"><span v-bind="attrs" v-on="on">
                <ActionButton :disabled="disableAll||!canCanceled"  class="ml-8 palette-4 bordered no-text" icon="close" @click="onCanceled" ></ActionButton>
            </span></template>
            <div class="pa-1 bordered text-small">Zet werkbon in status Vervallen</div>
        </v-tooltip>

        <v-tooltip  content-class="pa-0 text-body" right nudge-right="-60" nudge-bottom="36" color="white" open-delay="500">
            <template v-slot:activator="{ on, attrs }"><span v-bind="attrs" v-on="on">
                <ActionButton ml :disabled="disableAll||!canFinished"  class="palette-5 bordered no-text" icon="archive" @click="onFinished" ></ActionButton>
            </span></template>
            <div class="pa-1 bordered text-small">Verplaats werkbon naar archief</div>
        </v-tooltip>

    </span>
</template>



<script setup>
// Usage: 
//   import StatusButtons from '@/features/workorders/workorder/controls/StatusButtons'
//
//   <StatusButtons @onPlanned="onPlanned"></StatusButtons>
    import ActionButton from '@controls/buttons/ActionButton'

    import {computed, ref} from 'vue'

const props = defineProps({
    model: {
        type: [Object]
    },
    singleSelect: {
        type: Boolean,
        default: false
    },
    canPlanned: {
        type: Boolean,
        default: true
    },
    canExecuting: {
        type: Boolean,
        default: true
    },
    canExecuted: {
        type: Boolean,
        default: true
    },
    canFinished: {
        type: Boolean,
        default: true
    },
    canCanceled: {
        type: Boolean,
        default: true
    },
    disableAll: {
        type: Boolean,
        default: false
    },
    
})

const emit = defineEmits([
    'onPlanned',
    'onExecuting',
    'onExecuted',
    'onFinished',
    'onCanceled',
])

function onPlanned() {emit('onPlanned')} 
function onExecuting() {emit('onExecuting')} 
function onExecuted() {emit('onExecuted')} 
function onFinished() {emit('onFinished')} 
function onCanceled() {emit('onCanceled')} 


</script>
